import { useCallback } from 'react'

import { DashboardLayout } from '../../components/layout/DashboardLayout'
import { PaymentDetailsPanel } from './components/PaymentDetailsPanel'
import { PaymentStatRow } from './components/PaymentStatRow'
import { PaymentsTable } from './components/PaymentsTable'
import { PaymentsToolbar } from './components/PaymentsToolbar'
import { Breadcrumb } from '../../components/ui/Breadcrumb'
import type { RowAction } from '../../components/ui/RowActionsMenu'
import { shellAssets } from '../../constants/assets'
import { dashboardRoutes } from '../../constants/routes'
import { paymentTxnStatuses, paymentTxnStatusLabels } from '../../data/payments'
import { usePayments } from '../../hooks/usePayments'
import type { PaymentRecord } from '../../types'

const currentUser = {
  name: 'Admin',
  email: 'Admin@123gmail.com',
  avatar: shellAssets.avatar,
}

const PaymentsPage = () => {
  const {
    visible,
    summary,
    filters,
    setFilters,
    selected,
    selectPayment,
    setStatus,
    refundPayment,
    removePayment,
    isLoading,
    error,
  } = usePayments()

   const buildRowActions = (payment: PaymentRecord): RowAction[] => [
    {
      id: 'view',
      label: 'View details',
      onSelect: () => selectPayment(payment.id),
    },
  ]

  return (
    <DashboardLayout
      activeNavId="payments"
      contentGap={20}
      subtitle={
        <Breadcrumb
          items={[
            { label: 'Dashboard', path: dashboardRoutes.overview },
            { label: 'Payments' },
          ]}
        />
      }
      title="Payments"
      user={currentUser}
    >
      <div className="flex min-h-0 flex-col gap-[20px] lg:h-[calc(100dvh-180px)] lg:overflow-hidden"> 
        <PaymentStatRow
          summary={summary}
          isLoading={isLoading}
        />

        <div className="flex min-h-0 flex-1 flex-col gap-[17px] overflow-hidden xl:flex-row xl:items-stretch">
          <div className="flex min-h-0 min-w-0 w-full flex-1 flex-col gap-[11px] xl:h-full xl:max-w-[887px]">
            {error && (
              <p
                role="alert"
                className="font-host text-[13px] text-red-600"
              >
                {error}
              </p>
            )}
           <PaymentsToolbar filters={filters} onChange={setFilters} />


            
         <div className="min-h-0 w-full flex-1 overflow-y-auto overscroll-contain pr-[4px] [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
  <PaymentsTable
    buildRowActions={buildRowActions}
    onSelect={selectPayment}
    payments={visible}
    selectedId={selected?.id ?? null}
  />
</div>
          </div>

         <PaymentDetailsPanel payment={selected} />
        </div>
      </div>
    </DashboardLayout>
  )
}

export default PaymentsPage
